import {
    Component,
    ElementRef,
    OnDestroy,
    OnInit,
    ViewChild,
    Inject,
    Injector,
    AfterViewInit
} from '@angular/core';
import { DynamicBaseClass } from '../dynamic-base-class/dynamic-base-class.component';
import { Observable } from 'rxjs';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DatePipe } from '@angular/common';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

@Component({
  standalone: false,
    selector: 'app-dynamic-input',
    templateUrl: './input.component.html',
    styleUrls: ['./input.component.scss'],
})
export class InputComponent
    extends DynamicBaseClass
    implements OnInit, OnDestroy, AfterViewInit {

    @ViewChild('inputElement', { read: ElementRef, static: false }) inputElement: ElementRef<HTMLInputElement | HTMLTextAreaElement>;

    public value$: Observable<string>;
    public title$: Observable<string>;
    readonly: boolean = false;
    withClearButton: boolean = false;
    type: string = 'text';
    passwordHide: boolean = true;
    textAreaRows: number = 2;
    formGroupName: string;
    isRequired: boolean = false;
    min: number = 0;
    max: number = Number.MAX_VALUE;
    step: string = '1.0';
    dateFormat: string;
    locale: string;


    constructor(
        injector: Injector,
        @Inject(MAT_DATE_LOCALE) private _locale: string,
        @Inject(MAT_DATE_FORMATS) private _dateFormats: any,
        private _adapter: DateAdapter<any>,
        private _datepipe: DatePipe
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.locale = this._locale;
        this._adapter.setLocale(this.locale);
        this.dateFormat = this._dateFormats.parse.dateInput;
        
        this.value$ = this.GetValueFromConfig();
        this.title$ = this.GetTitleFromConfig();
        if (this.config) {
            this.readonly = this.config.readonly ?? false;
            this.withClearButton = this.config.withClearButton ?? false;
            this.type = this.config.type ?? 'text';
            this.textAreaRows = this.config.textAreaRows ? Number(this.config.textAreaRows) : 2;
            this.formGroupName = this.config.formGroupName;
            this.isRequired = this.config.isRequired ?? false;
            this.min = this.config.min ? Number(this.config.min) : 0;
            this.max = this.config.max ? Number(this.config.max) : Number.MAX_VALUE;
            this.step = this.config.step ? this.config.step : '1.0';
            if (this.config.minFromDataStore) {
                this.dynamicUiServices.GetValueAsObservable(this.config.minFromDataStore, this.storeDataChildNames).subscribe((value) => {
                    this.min = value;
                });
            }
            if (this.config.maxFromDataStore) {
                this.dynamicUiServices.GetValueAsObservable(this.config.maxFromDataStore, this.storeDataChildNames).subscribe((value) => {
                    this.max = value;
                });
            }
        }
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
    }

    ngAfterViewInit(): void {
        if (this.formGroupName) {
            this.dynamicUiServices.AddControlToFormControls(this.formGroupName, this.inputElement);
        }
    }

    onModelChange(value: string) {
        if (this.type === 'number') {
            if (value === '') {
                value = '0';
            }
            this.SetValueFromConfig(value);
        }
        else {
            this.SetValueFromConfig(value);
        }
    }

    onModelChangeDate(event: MatDatepickerInputEvent<Date>) {
        if (event.value !== null && !isNaN(Date.parse(event.value.toString()))) {
            this.SetValueFromConfig(this._datepipe.transform(event.value, 'yyyy-MM-ddT00:00:00'));
        }
    }

    clearValue() {
        if (this.type === 'number') {
            this.inputElement.nativeElement.value = "0";
            this.SetValueFromConfig('0');
            this.inputElement.nativeElement.dispatchEvent(new Event('blur'));
        }
        else {
            this.inputElement.nativeElement.value = "";
            this.SetValueFromConfig('');
            this.inputElement.nativeElement.dispatchEvent(new Event('blur'));
        }
    }
}
